import { Component, EventEmitter, Input, Output } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MenuService } from '../../services/menu.service';
import { GenericCollectionService } from '../../services/collection-service.service';
import { MenuComponent } from '../menu/menu.component';
import { NavigationService } from '../../services/navigation-service.service';

@Component({
  selector: 'app-header',
  imports: [RouterModule, MenuComponent],
  templateUrl: './app-header.component.html',
  styleUrl: './app-header.component.css'
})
export class AppHeaderComponent {

  @Input() currentTopicName: string = '';

  constructor(private menuService: MenuService,
    private collectionService: GenericCollectionService<any>,
    private navigationService: NavigationService) { }

  onMenuToggle(): void {
    this.menuService.toggleMenu();
  }

  getCurrentTopicName(): string {
    return this.menuService.getCurrentTopicName();
  }

  navigateToHome() {
    this.navigationService.navigateToHome();
    this.menuService.closeMenu();
  }

}
